import {getTestProps} from '@benchling/js-test-utils';

// This is re-exported from the shared module to avoid needing to update the call sites in hundreds of files
// to instead import from the shared module.

export default getTestProps;
